export const GET_BD = "GET_BD";

export const OPEN_BD_DIALOG = "OPEN_BD_DIALOG";
export const CLOSE_BD_DIALOG = "CLOSE_BD_DIALOG";
export const VIP_SWITCH_BD = "VIP_SWITCH_BD";
